import {
    RaikoButtonPrimary,
    RaikoFlexAlignEnd,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoMaterialOutlinedInput,
    RaikoMobileInputOutlined,
    RaikoNumberInputOutlined,
    RaikoToggleOutlined, showErrorMessage, showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {useState} from "react";
import {FundService} from "../../serverService/fund/FundService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {stringIsEmpty} from "../../util/VariableChecker";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

export default function FundAddNewAdmin({handleAddNewItemToTable}) {

    const service = new FundService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [nationalCode, setNationalCode] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [enabled, setEnabled] = useState(false);

    function handleCreateNewAdmin() {
        if (checkFields()) {
            loading.show()
            service.CreateFundAdmin(
                firstName,
                lastName,
                nationalCode,
                phoneNumber,
                username,
                password,
                enabled
            ).then(response => {
                showSuccessMessage("مدیر جدید با موفقیت افزوده شد.")
                handleAddNewItemToTable({
                    firstName,
                    lastName,
                    nationalCode,
                    phoneNumber,
                    username,
                    enabled
                })
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }
    }

    function checkFields() {
        let message
        let state = false

        if (stringIsEmpty(firstName))
            message = "لطفا نام مدیر را وارد نمایید."
        else if (stringIsEmpty(lastName))
            message = "لطفا نام خانوادگی مدیر را وارد نمایید."
        else if (!nationalCode || (nationalCode.length < 8 || nationalCode.length > 11))
            message = "لطفا شماره ملی مدیر را به درستی وارد نمایید."
        else if (!phoneNumber || phoneNumber.length !== 11)
            message = "لطفا شماره همراه مدیر را به درستی وارد نمایید."
        else if (stringIsEmpty(username))
            message = "لطفا نام کاربری مدیر را وارد نمایید."
        else if (!password || (password.length < 8))
            message = "رمز عبور حداقل می بایست ۸ کاراکتر باشد."
        else
            state = true

        if (message)
            showWarningMessage(message)

        return state
    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;`}>
            <RaikoGridTwoColumn>
                <RaikoMaterialOutlinedInput labelText={"نام"} value={firstName} setValue={setFirstName}/>
                <RaikoMaterialOutlinedInput labelText={"نام خانوادگی"} value={lastName} setValue={setLastName}/>
                <RaikoNumberInputOutlined
                    labelText={"کدملی"}
                    value={nationalCode}
                    setValue={value => {
                        if (!value || value.length < 11)
                            setNationalCode(value)
                    }}
                />
                <RaikoMobileInputOutlined labelText={"شماره همراه"} value={phoneNumber} setValue={setPhoneNumber}/>
                <RaikoMaterialOutlinedInput labelText={"نام کاربری"} value={username} setValue={setUsername}/>
                <RaikoMaterialOutlinedInput labelText={"رمز عبور"} value={password} setValue={setPassword}/>
            </RaikoGridTwoColumn>
            <RaikoToggleOutlined checked={enabled} setChecked={setEnabled} labelText={"فعال/غیرفعال"}/>
            <RaikoFlexAlignEnd>
                <RaikoButtonPrimary label={"افزودن"} onClick={handleCreateNewAdmin}/>
            </RaikoFlexAlignEnd>

        </RaikoGridOneColumn>
    )
}
